var layout = {
  isDesktop : function(){
    return $('body').width() > 840;
  },
};